/**
 * Sentry initialization for NoFee.restaurant frontend.
 * Must be imported as the FIRST statement in index.js (before React).
 * No-ops cleanly when DSN is empty (e.g. during local development).
 */
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN_FRONTEND;
const environment = process.env.REACT_APP_ENVIRONMENT || 'production';

if (dsn && dsn.trim() !== '') {
  Sentry.init({
    dsn,
    environment,
    // Lower sampling in production to control cost
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: environment === 'production' ? 0.1 : 0.5,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true }),
    ],
    // Drop common noisy errors
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Non-Error promise rejection captured',
    ],
  });
}
